/**
 * Numeral Formatter using numeral js
 * @see http://numeraljs.com/
 */
import numeral from 'numeral';
export function abbreviate(value) {
    return numeral(Number(value)).format('0a');
}
